// Import packages
import React from 'react';
import {connect} from "react-redux";
import {Route, useRouteMatch} from "react-router-dom";

// Import assets
import './users.scss';

// ImportComponents
import Persons from "./persons/Persons";
import New from "./new/New";

// Import Utils
import {getPropsFromState} from "../../../../redux/mapStateToProps";
import {LayoutContainer} from "../../../../modules/Layout";
import {useTranslation} from "react-i18next";

function Users(props) {
    const {path} = useRouteMatch();
    const {t} = useTranslation();

    return (
        <>

                <Route path={`${path}/persons/(userId)?/:userId?/(personId)?/:personId?`} component={Persons}/>
                <Route path={`${path}/new`} component={New}/>
        </>
    );
}


const mapStateToProps = (state) => {
    return getPropsFromState(state, ['isFullWidth'])
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Users);
